import React from 'react';
import { NoResultsContainer } from './noResultsStyles';

const NoResults = () => {
	return <NoResultsContainer>No results for this search</NoResultsContainer>;
};

export default NoResults;
